// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {createCustomer} from '../../../customer/shared/repositories';
import {readFilteredEndUseCodes} from './filtered-end-use-codes';
import {readFilteredPurchaserType} from './filtered-purchaser-type';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateRegistration} from './registration';
import {updateRegistrationModals} from './registration-modals';

export const createRegistrationFormCustomer = (entityId, product) =>

    async dispatch => {

        updateRegistrationModals('customerSearchModal', false)(dispatch);

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await createCustomer(entityId);

            const filter1 = {filter1Key: 'INDUSTRY_INDICATOR', filter1Operator: 'eq', filter1Value: product.industryIndicator};
            const filter2 = {filter2Key: 'DEALER_ID', filter2Operator: 'eq', filter2Value: product.dealer.account};
            const filter3 = {filter3Key: 'CUST_TYPE', filter3Operator: 'eq', filter3Value: data.type[0]};

            successAlertBar(translate('CUSTOMER_CREATED_SUCCESSFULLY'));
            updateRegistration('customer', data)(dispatch);
            readFilteredEndUseCodes(filter1, filter2, filter3)(dispatch);
            readFilteredPurchaserType('CUST_TYPE', 'eq', data.type[0])(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/create-customer.js